import { Modal } from "react-bootstrap";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Puff } from "react-loading-icons";
import "../../../Campaigns/Campaigns.css";

function SpotModal({ show, handleModalhide }) {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState("venue");
  const navigate = useNavigate();

  const handleSelectOption = (option) => {
    setSelectedOption(option);
  };

  const handleSubmitForm = async () => {
    if (!selectedOption) return;
    setIsLoading(true);
    // Simulate a small delay for premium feel or actual logic if needed
    setTimeout(() => {
      handleModalhide();
      navigate(`/my/nightspots/create/FREE`, { state: { type: selectedOption } });
      setIsLoading(false);
    }, 500);
  };

  const options = [
    {
      id: "venue",
      title: "Estabelecimento",
      description: "Um espaço físico fixo (ex: Discoteca, Bar, Restaurante).",
      icon: "fa-building",
    },
    {
      id: "organization",
      title: "Organização",
      description: "Promotor ou grupo que organiza eventos em vários locais.",
      icon: "fa-calendar-check",
    },
  ];

  const InsideLoading = () => (
    <div className="d-flex flex-column align-items-center justify-content-center py-5">
      <Puff stroke="#6366f1" height="4em" width="4em" />
      <div className="text-muted mt-3 fw-bold">A preparar...</div>
    </div>
  );

  return (
    <Modal
      show={show}
      onHide={handleModalhide}
      centered
      contentClassName="campaign-card border-0 p-0 overflow-hidden"
    >
      <div className="modal-header border-0 p-4 pb-0 d-flex align-items-center">
        <div>
          <h2 className="campaigns-section-title fs-3 mb-1">O que vais criar?</h2>
          <p className="campaigns-section-subtitle mb-0 small text-muted">Escolha o perfil que melhor descreve o teu negócio.</p>
        </div>
      </div>

      {isLoading ? (
        <InsideLoading />
      ) : (
        <>
          <Modal.Body className="p-4 pt-4">
            <div className="row g-3">
              {options.map((option) => (
                <div className="col-12" key={option.id}>
                  <div
                    onClick={() => handleSelectOption(option.id)}
                    className={`instruction-box p-3 rounded-4 border transition-all cursor-pointer d-flex align-items-center ${selectedOption === option.id
                      ? "border-primary bg-primary bg-opacity-10 glass-glow"
                      : "border-white border-opacity-10 hover-bg-white-5"
                      }`}
                    style={{ cursor: 'pointer', transition: 'all 0.2s ease' }}
                  >
                    <div className={`icon-box-premium me-3 flex-shrink-0 ${selectedOption === option.id ? "text-primary" : "text-muted"}`}
                      style={{ width: '50px', height: '50px', fontSize: '1.2rem' }}>
                      <i className={`fa-solid ${option.icon}`}></i>
                    </div>
                    <div className="flex-grow-1">
                      <h4 className={`fs-6 fw-bold mb-1 ${selectedOption === option.id ? "text-white" : "text-muted"}`}>
                        {option.title}
                      </h4>
                      <p className="text-muted small mb-0 opacity-75">{option.description}</p>
                    </div>
                    <div className="ms-3">
                      <div className={`rounded-circle d-flex align-items-center justify-content-center ${selectedOption === option.id ? "bg-primary text-white" : "border border-white border-opacity-20 text-transparent"}`}
                        style={{ width: '24px', height: '24px', fontSize: '0.7rem' }}>
                        {selectedOption === option.id && <i className="fa-solid fa-check"></i>}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Modal.Body>
          <Modal.Footer className="border-0 p-4 pt-0 mt-2">
            <button
              className="btn-action btn-campaign-secondary px-4 py-2 rounded-pill w-auto me-2"
              onClick={handleModalhide}
            >
              Cancelar
            </button>
            <button
              className="btn-action glass-glow btn-campaign-primary px-5 py-2 rounded-pill w-auto"
              onClick={handleSubmitForm}
              disabled={!selectedOption}
            >
              <i className="fa-solid fa-chevron-right me-2"></i>Continuar
            </button>
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
}

export default SpotModal;
